<template>
  <div>
    <!-- done users items  -->
    <div
      class="users-container p-4 pb-2 flex flex-col items-center relative overflow-hidden mb-4"
      v-if="!doneItemsLoading"
    >
      <div class="flex items-center w-full">
        <h4
          v-if="
            !doneItemsLoading && doneUsersItems && doneUsersItems.length > 0
          "
          class="mr-2 w-26"
        >
          To Review
        </h4>

        <div
          class="w-full flex flex-wrap items-center justify-between"
          v-else-if="
            !doneItemsLoading && doneUsersItems && doneUsersItems.length === 0
          "
        >
          <h4 class="mr-2">No pending review found</h4>
          <div class="flex items-center justify-end">
            <vue-circle
              :progress="remainingTimePercentage"
              :key="remainingTimePercentage"
              :size="20"
              :reverse="false"
              line-cap="round"
              :fill="fill"
              empty-fill="rgba(0, 0, 0, .1)"
              :animation-start-value="0.0"
              :start-angle="0"
              insert-mode="append"
              :thickness="4"
              :show-percent="false"
              class="mr-2 flex"
            />
            Next update in approximately {{ formattedRemainingTime }}
          </div>
        </div>
        <div
          class="flex items-center w-1"
          v-if="doneUsersItems && doneUsersItems.length > 0"
        >
          <div v-for="(user, index) in doneUsersItems" :key="index">
            <vx-tooltip
              class="capitalize"
              :text="`${user.userData.firstName} ${user.userData.lastName}`"
            >
              <vs-avatar
                @click.stop="
                  $router.push({
                    name: 'org-users-done-items-reviews',
                    query: { userId: user.userData._id },
                  })
                "
                :style="borderStyle('done', true)"
                size="40px"
                class="m-1 w-100 z-10"
                v-if="user.userData.profilePictureUrl"
                :src="`${constants.s3Bucket}/editor/profile-pictures/${user.userData.profilePictureUrl}`"
              />

              <vs-avatar
                @click.stop="
                  $router.push({
                    name: 'org-users-done-items-reviews',
                    query: { userId: user.userData._id },
                  })
                "
                :style="borderStyle('done', true)"
                v-else
                size="40px"
                class="m-1"
                :src="`https://hostedboringavatars.vercel.app/api/beam?name=${avatarNameGenerator(
                  user.userData.firstName || 'boringAvatar',
                  user.userData.lastName || 'boringAvatar'
                )}`"
              />
            </vx-tooltip>
          </div>
        </div>
      </div>

      <div class="absolute flex flex-col items-end h-100 next-2 z-10 pr-4 pl-0">
        <vx-tooltip class="capitalize" text="View All">
          <img
            v-if="doneUsersItems && doneUsersItems.length"
            class="arrow next right-4 m-1 lg:mt-2"
            src="@/assets/images/icons/next-arrow.svg"
            alt=""
            @click="
              $router.push({
                name: 'org-users-done-items-reviews',
              })
            "
          />
        </vx-tooltip>
      </div>

      <div
        v-if="doneUsersItems && doneUsersItems.length"
        class="flex items-center w-full justify-end"
      >
        <vue-circle
          :progress="remainingTimePercentage"
          :key="remainingTimePercentage"
          :size="20"
          :reverse="false"
          line-cap="round"
          :fill="fill"
          empty-fill="rgba(0, 0, 0, .1)"
          :animation-start-value="0.0"
          :start-angle="0"
          insert-mode="append"
          :thickness="4"
          :show-percent="false"
          class="mr-1"
        />
        Next update in approximately {{ formattedRemainingTime }}
      </div>
    </div>

    <!-- Skeleton  -->
    <div v-if="assignmentLoading">
      <div
        v-for="i in 5"
        :key="i"
        class="border border-blue-300 shadow rounded-lg p-4 w-full animate-pulse h-48 my-6"
        style="background: #8080805e"
      ></div>
    </div>

    <!-- assignments to review  -->
    <div
      v-if="orgAssignments && orgAssignments.length > 0 && !assignmentLoading"
    >
      <task-card
        @assignmentToValidate="assignmentToValidate"
        v-for="(assignment, i) in orgAssignments"
        :key="i"
        :assignment="assignment"
        :orgId="orgId"
        :orgColor="orgColor"
      />
    </div>
    <div
      v-else-if="
        orgAssignments && orgAssignments.length === 0 && !assignmentLoading
      "
      class="flex items-center justify-center"
    >
      <div
        class="no-assignments flex flex-col items-center justify-center lg:w-3/4 gap-4 mt-4"
      >
        <img class="lg:w-4/12 w-64" src="@/assets/images/temp-img/review.svg" />

        <p
          class="text-xl text-center flex gap-2 flex-col font-semibold text-black"
        >
          Check back later!

          <br />

          <span class="font-normal text-slate-400 text-base"
            >It's possible that new assignments will become available for review
            at a later time. You could check back periodically to see if any new
            assignments have been posted.</span
          >
        </p>
      </div>
    </div>

    <!-- Add validation popup -->
    <add-validation-modal
      v-if="addValidationPopup"
      :assignment="selectedAssignment"
      :orgId="orgId"
      class="absolute"
    />
  </div>
</template>
<script>
import TaskCard from "./components/TaskCard.vue";
import reviewMixin from "./reviewMixin";
import AddValidationModal from "@/modals/AddValidation.vue";
import VueCircle from "vue2-circle-progress";

export default {
  components: {
    TaskCard,
    AddValidationModal,
    VueCircle,
  },
  data() {
    return {
      selectedAssignment: {},
      remainingUpdateTime: 0,
      fill: { gradient: ["#0DDBB3", "#0DDBB3"] },
    };
  },
  mixins: [reviewMixin],
  mounted() {
    if (this.orgAssignments.length > 0) {
      this.assignmentLoading = false;
    }
    this.getDoneUsersItems(this.orgData._id);
    this.getNextUpdateTime();
  },
  computed: {
    addValidationPopup() {
      return this.$store.state.modals.addValidationPopup;
    },
    orgAssignments() {
      return this.$store.state.alex.orgAssignments;
    },
    formattedRemainingTime() {
      if (this.remainingUpdateTime <= 0) {
        return "";
      }

      let remainingHours = Math.floor(
        this.remainingUpdateTime / (60 * 60 * 1000)
      );
      let remainingMinutes = Math.floor(
        (this.remainingUpdateTime % (60 * 60 * 1000)) / (60 * 1000)
      );
      let remainingSeconds = Math.floor(
        (this.remainingUpdateTime % (60 * 1000)) / 1000
      );

      return `${remainingHours > 0 ? remainingHours : ""}${
        remainingHours > 0 ? "hr:" : ""
      }
      ${remainingMinutes > 0 ? remainingMinutes : ""}${
        remainingMinutes > 0 ? "mins:" : ""
      }
${remainingSeconds}s`;
    },
    remainingTimePercentage() {
      if (this.remainingUpdateTime <= 0) {
        return 0;
      }
      let totalTime = 3 * 60 * 60 * 1000;
      let percentage =
        ((totalTime - this.remainingUpdateTime) / totalTime) * 100;
      return parseInt((100 - percentage).toFixed(2)); // Round to 2 decimal places
    },
  },
  watch: {
    orgAssignments: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          this.$store.commit("alex/SET_ORG_ASSIGNMENTS", newVal);
        }
      },
    },
  },
  methods: {
    assignmentToValidate(val) {
      this.selectedAssignment = val;
    },
    getNextUpdateTime() {
      const currentDateTime = new Date();
      const currentISOString = currentDateTime.toISOString();
      const currentDateString = currentISOString.split("T")[0];
      const currentHour = parseInt(
        currentISOString.split("T")[1].slice(0, -5).split(":")[0],
        10
      );
      const roundedHour = Math.ceil(currentHour / 3) * 3;
      const nextOccurrenceString = `${currentDateString}T${roundedHour
        .toString()
        .padStart(2, "0")}:00:00.000Z`;

      let nextOccurrence = new Date(nextOccurrenceString);

      if (nextOccurrence - currentDateTime <= 0) {
        nextOccurrence = new Date(
          nextOccurrence.getTime() + 3 * 60 * 60 * 1000
        );
      }

      // Calculate the remaining time until the next occurrence
      let remainingTime = nextOccurrence - new Date();
      this.remainingUpdateTime = remainingTime;
      setInterval(() => {
        this.remainingUpdateTime -= 1000; // Subtract 1 second
      }, 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
.users-container {
  background: #fff;
  box-shadow: 0px 4px 36px rgba(24, 144, 251, 0.1);
  border-radius: 0.5rem;

  h4 {
    color: #101828 !important;
    font-weight: 600;
  }

  .arrow {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    // background-color: #f2f4f7;
    color: #98a2b3;
    // border: 2px solid #d0d5dd;
    font-size: 22px;
    cursor: pointer;
    transition: all 0.3s ease;

    span {
      font-weight: 700;
      color: #98a2b3;
    }
  }
  .next {
    right: 1em;
    &-2 {
      right: 0;
      background: #fff;
    }
  }
}

.no-assignments {
  width: 75%;
  h4 {
    color: #6b7285 !important;
  }
}
</style>
